<template>
    <div class="h2-wrapper">
        <h2 class="hh2" :id="id || null" @click="toggleContent">
            <slot></slot>
            <span v-if="hasContent" class="toggle-btn">
                {{ isHidden ? '+' : '-' }}
            </span>
        </h2>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: ''
        },
        hide: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isHidden: true
        }
    },
    created() {
        this.isHidden = this.hasContent ? true : false;
        if (this.hide !== undefined) {
            this.isHidden = this.hide;
        }
    },
    computed: {
        hasContent() {
            return !!this.$slots.content;
        }
    },
    methods: {
        toggleContent() {
            if (!!this.$slots.content === false) return;
            console.log('toggleContent');
            this.isHidden = !this.isHidden
        }
    }
}
</script>

<style lang="scss" scoped>
.h2-wrapper {
    margin: 20px 0;
}

.hh2 {
    font-size: 24px;
    background: #395e6b;
    color: #fff;
    font-weight: 600;
    margin: 30px 0 20px;
    padding: 10px;
    position: relative;
    border-bottom: 2px solid rgba(0, 102, 204, 0.2);
    cursor: pointer;
    align-items: center;
    gap: 10px;
    display: flex;
}




@media (max-width: 768px) {
    .hh2 {
        font-size: 20px;
        margin: 25px 0 15px;
    }
}
</style>
